import {Component, OnDestroy, OnInit} from "@angular/core";
import {BaseComponent} from "../../../base.component";
import {UserService} from "../../../common/user.service";
import {CatalogService} from "../catalog.service";
import {LoggerService} from "../../../common/logger.service";
import {ICatalogView} from "../catalog-models";
import {Subscription} from "rxjs";
import {Constants} from "../../../constants";
import {IShareLinkOptions} from "../../../social/social-models";
import {MarkupService} from "../../../common/markup.service";
import {TranslateService} from "../../../translation/translate.service";
import {IShopUser} from "../../../session/customer-models";
import {LocaleUtil} from "../../../util/locale-util";

@Component({
    selector: 'catalog-header',
    templateUrl: './catalog-header.component.html',
    styleUrls: ['./catalog-header.component.scss'],
    standalone: false
})
export class CatalogHeaderComponent extends BaseComponent implements OnInit, OnDestroy {

    private static SHOP_ALL_TAG: string = 'cart.shop.all.products';
    displayUrlCatalogShareables: boolean = false;
    displayFbCatalogShareables: boolean = false;
    shareOptions: IShareLinkOptions;
    filterView: ICatalogView;
    filterViewSubscription: Subscription;

    constructor(
        private catalogService: CatalogService,
        private userService: UserService,
        private markupService: MarkupService,
        private loggerService: LoggerService,
        private translateService: TranslateService
    ) {
        super(userService, loggerService);
    }

    ngOnInit() {
        this.filterViewSubscription = this.catalogService.filterView$.subscribe((filterView) => {
            if (!!filterView.selectedCategory || !!filterView.selectedTag) {
                this.filterView = filterView;
                this.setSharingLinks();
            } else {
                this.filterView = filterView;
            }
        });
    }

    ngOnDestroy(): void {
        if (this.filterViewSubscription) {
            this.filterViewSubscription.unsubscribe();
        }
    }

    setSharingLinks(): void {
        this.getCustomerData().then((user: IShopUser) => {
            this.displayUrlCatalogShareables = this.showUrlShareables && this.showCart;
            this.displayFbCatalogShareables = this.showFbShareables && this.displayUrlCatalogShareables;
            // need to check tag first because there will always be a category selected, even if it's "all"
            if (!!this.filterView.selectedTag && !!this.filterView.selectedTag.id) {
                this.setPageTitle(this.filterView.selectedTag.translationTag);
                this.markupService.setOgSingleTagPage(this.filterView.selectedTag, LocaleUtil.getTranslationLocale(user));
                this.shareOptions = {
                    shareType: Constants.SHARE_TYPE_TAG,
                    shareId: this.filterView.selectedTag.id.toString(),
                    shareFrom: Constants.TAG_CATALOG_STATE
                };
            } else if (!!this.filterView.selectedCategory && !!this.filterView.selectedCategory.id) {
                if (this.filterView.selectedCategory.id === -1) {
                    this.setPageTitle();
                } else {
                    this.setPageTitle(this.filterView.selectedCategory.translationTag);
                }
                this.markupService.setOgSingleCategoryPage(this.filterView.selectedCategory, LocaleUtil.getTranslationLocale(user));
                this.shareOptions = {
                    shareType: Constants.SHARE_TYPE_CATEGORY,
                    shareId: this.filterView.selectedCategory.id.toString(),
                    shareFrom: Constants.CATALOG_STATE
                };
            }
        });
    }

    setPageTitle(translationTag?: string): void {
        this.translateService.translate(translationTag ?? CatalogHeaderComponent.SHOP_ALL_TAG).then((translation) => {
            this.markupService.setTitle(translation + Constants.USANA_PAGE_TITLE_ENDING);
        });
    }
}
